"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppsItem = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var useHeaderProps_1 = require("../../../hooks/useHeaderProps");
var useDisplayMode_1 = require("../useDisplayMode");
var DropdownOption_1 = require("../../_shared/DropdownOption");
var Icon_1 = require("../../../../Icon");
var NavLink_1 = require("../../_shared/NavLink");
var colors_1 = require("../../../colors");
var NavMenu_1 = require("../../_shared/NavMenu");
var AppsItem = function () {
    var _a = (0, useHeaderProps_1.useHeaderProps)(), _js = _a._js, permissions = _a.permissions, installedApps = _a.installedApps, activeItem = _a.activeItem;
    var displayMode = (0, useDisplayMode_1.useDisplayMode)();
    var hasInstalledApps = installedApps && installedApps.length > 0;
    var showAppsHeaderButton = hasInstalledApps || (permissions === null || permissions === void 0 ? void 0 : permissions.canIViewAppMarketplace);
    var content = (React.createElement(React.Fragment, null,
        hasInstalledApps && React.createElement(InstalledApps, null),
        (permissions === null || permissions === void 0 ? void 0 : permissions.canIViewAppMarketplace) && React.createElement(AppsMarketplace, null)));
    if (!showAppsHeaderButton)
        return React.createElement(React.Fragment, null);
    return displayMode === 'main' ? (React.createElement(NavMenu_1.NavMenu, null,
        React.createElement(NavMenu_1.NavMenuButton, { underlined: activeItem === 'apps', "date-feature-id": "header_dropdown_apps" }, _js('Apps')),
        React.createElement(NavMenu_1.NavMenuList, null, content))) : (content);
};
exports.AppsItem = AppsItem;
var InstalledApps = function () {
    var _a = (0, useHeaderProps_1.useHeaderProps)(), _js = _a._js, installedApps = _a.installedApps;
    var displayMode = (0, useDisplayMode_1.useDisplayMode)();
    return (React.createElement(React.Fragment, null,
        displayMode !== 'hamburger' && (React.createElement(react_1.Text, { fontSize: 14, p: 4, color: colors_1.DEFAULT_TEXT_COLOR, fontWeight: "bold" }, _js('Installed Apps'))), installedApps === null || installedApps === void 0 ? void 0 :
        installedApps.map(function (app) {
            var linkProps = {
                key: app.appKey,
                href: app.route,
                className: "header-link__installed-app_".concat(app.appKey),
            };
            return displayMode === 'hamburger' ? (React.createElement(NavLink_1.NavLink, __assign({}, linkProps, { "data-feature-id": "header_link_installed_app_".concat(app.appKey) }), app.name)) : (React.createElement(DropdownOption_1.DropdownOption, __assign({}, linkProps), app.name));
        })));
};
var AppsMarketplace = function () {
    var _js = (0, useHeaderProps_1.useHeaderProps)()._js;
    var displayMode = (0, useDisplayMode_1.useDisplayMode)();
    var linkProps = {
        href: '/Apps/Marketplace',
        className: 'header-link__explore-apps',
        'data-feature-id': 'header_link_explore_apps',
    };
    return displayMode === 'hamburger' ? (React.createElement(NavLink_1.NavLink, __assign({}, linkProps), _js('Explore Apps'))) : (React.createElement(DropdownOption_1.DropdownOption, __assign({}, linkProps),
        _js('Explore Apps'),
        React.createElement(Icon_1.Icon, { type: pro_solid_svg_icons_1.faArrowRight, ml: 2 })));
};
